import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import {Observable, throwError} from 'rxjs';
import { environment } from 'src/environments/environment';
import {CustomsValidators} from '../../validators/custom.validators';


@Injectable({
  providedIn: 'root'
})
export class CaptchaService {

  urlGoogleVerify = `${environment.bffBaseUrl}/sar/public/ValidateForm`;
  urlPostPublicForm = `${environment.bffBaseUrl}/sar/public/SendForm`;
  urlPostSelfVerification = `${environment.bffBaseUrl}/sar/public/SelfValidationEmail`;
  urlExcelValidation = `${environment.bffBaseUrl}/sar/public/ValidateExcel`;
  urlValidateMedicalForm = `${environment.bffBaseUrl}/sar/public/ValidateMedicalForm`;
  urlPutMedicalForm = `${environment.bffBaseUrl}/sar/public/sendMedicalForm`;
  constructor(private http: HttpClient) {
  }


  verifyCaptcha(response, publicJwt): Observable<any> {
    const headersObject = new HttpHeaders().set('authorization', 'Bearer ' + publicJwt);
    const data = { response };
    const urlBuilder = this.urlGoogleVerify;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, data, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

  excelPeople(file: FormData, publicJwt): Observable<any> {
    const headersObject = new HttpHeaders().set('authorization', 'Bearer ' + publicJwt);
    const urlBuilder = this.urlExcelValidation;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, file, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }
  postFormPublic(data, publicJwt): Observable<any> {
    const headersObject = new HttpHeaders().set('authorization', 'Bearer ' + publicJwt);
    const urlBuilder = this.urlPostPublicForm;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, data, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }
  postFormSelfVerification(data): Observable<any> {
    // const headersObject = new HttpHeaders().set("authorization", "Bearer "+publicJwt)
    const urlBuilder = this.urlPostSelfVerification;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.post(urlBuilder, data
      // , {
      // headers: headersObject
      // }F
    ) : throwError(CustomsValidators.msgNotValidUrl);
  }
  getMedicalTest(publicJwt): Observable<any> {
    const headersObject = new HttpHeaders().set('authorization', 'Bearer ' + publicJwt);
    const urlBuilder = this.urlValidateMedicalForm;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.get(urlBuilder, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }
  putMedicalTest(data, publicJwt): Observable<any> {
    const headersObject = new HttpHeaders().set('authorization', 'Bearer ' + publicJwt);
    const urlBuilder = this.urlPutMedicalForm;
    return CustomsValidators.isValidUrl(urlBuilder) ? this.http.put(urlBuilder, data, {
      headers: headersObject
    }) : throwError(CustomsValidators.msgNotValidUrl);
  }

}
